/* eslint-disable complexity */
const ACTION_TYPES = require('../actions/Actions').TYPES;
const PROFILE_ACTION_TYPES = require('./profile').ACTION_TYPES;

const initialState = {
    isRwd: false,
    showBccModal: false,
    showRegisterModal: false,
    showSignInModal: false,
    showSignInWithMessagingModal: false,
    showBiRegisterModal: false,
    showForgotPasswordModal: false,
    showInfoModal: false,
    showKlarnaModal: false,
    klarnaInstallment: null,
    klarnaTotalAmount: null,
    infoModalTitle: '',
    infoModalMessage: '',
    infoModalButtonText: '',
    infoModalFooterColumns: null,
    infoModalCallback: null,
    showInfoModalCancelButton: false,
    showCloseButton: false,
    infoModalCancelText: '',
    infoModalMessageIsHtml: false,
    confirmMsgObj: {},
    showMediaModal: false,
    mediaModalId: '',
    mediaModalTitle: '',
    mediaModalClose: null,
    mediaModalCloseDataAt: null,
    mediaModalBodyDataAt: null,
    dismissButtonText: '',
    dismissButtonDataAt: '',
    modalDataAt: '',
    showSampleModal: false,
    showVideoModal: false,
    showRewardModal: false,
    showApplyRewardsModal: false,
    rewardsType: null,
    showOrderConfirmRewardModal: false,
    sampleList: null,
    rewardList: null,
    allowedQtyPerOrder: 0,
    samplesMessage: '',
    showPromoModal: false,
    showColorIQModal: false,
    colorIQModalCallback: null,
    promoCode: null,
    promosList: null,
    maxMsgSkusToSelect: 0,
    instructions: '',
    showFindInStoreModal: false,
    showFindInStoreMapModal: false,
    storesToShow: null,
    zipCode: null,
    searchedDistance: null,
    currentProduct: null,
    showCountrySwitcherModal: false,
    showInternationalShippingModal: false,
    bccModalTemplate: null,
    signInMessages: null,
    signInCallback: null,
    signInErrback: null,
    signInSource: '',
    registerCallback: null,
    registerErrback: null,
    biRegisterCallback: null,
    biRegisterCancellationCallback: null,
    extraParams: null,
    showQuickLookModal: false,
    quickLookProduct: null,
    skuType: null,
    quickLookSku: null,
    addedProduct: null,
    addedSku: null,
    itemQty: 0,
    desiredCountry: null,
    desiredLang: null,
    presetLogin: null,
    switchCountryName: null,
    showEmailMeWhenInStockModal: false,
    showEditMyProfileModal: false,
    showEditFlowModal: false,
    editFlowTitle: '',
    editFlowContent: null,
    biAccount: null,
    socialProfile: null,
    saveProfileCallback: null,
    saveBeautyTraitCallBack: null,
    showShareLinkModal: false,
    showCancelReservationModal: false,
    showOrderCancelationModal: false,
    canceledOrderId: null,
    selfCancelationReasons: null,
    showAddToBasketModal: false,
    preferredStoreName: null,
    subTitle: '',
    error: null,
    showSocialRegistrationModal: false,
    socialRegistrationProvider: null,
    showSocialReOptModal: false,
    socialReOptCallback: null,
    isEditProfileFlow: false,
    isCommunity: false,
    showProductFinderModal: false,
    guidedSellingData: null,
    showAuthenticateModal: false,
    showPhoneNumberModal: false,
    showBookWidgetModal: false,
    experienceDetail: {},
    showGoogleMapModal: false,
    reservation: null,
    getGuestDetails: null,
    showProductMediaZoomModal: false,

    //Rouge Reward Card Modal
    showRougeRewardCardModal: false,
    rougeRewardCardModalSku: null,
    rougeRewardCardModalCallback: null,

    showCreditCardPrescreenModal: false,
    showScanRewardCardModal: false,
    showCreditReportDetailsModal: false,
    showExtendSessionModal: false,
    showExtendSessionFailureModal: false,

    showAddressVerificationModal: false,
    verificationType: '',
    currentAddress: null,
    recommendedAddress: null,
    verificationSuccessCallback: null,
    verificationCancelCallback: null,

    showSimilarProducts: false,
    isCleanProductsModal: false,
    recommendedProductIDs: '',
    brandName: null,
    productName: null,
    productImages: null,
    itemId: null,

    showReserveAndPickUpModal: false,
    reserveAndPickUpModalCallback: null,
    reserveAndPickUpModalMountCallback: null,
    reserveAndPickUpModalCancelCallback: null,
    disableNonBopisStores: false,
    disableOutOfStockStores: false,
    pickupInsteadModalRef: null,
    isRopisSelected: false,
    location: null,
    useBackToStoreLink: false,
    isBopis: false,

    showReviewImageModal: false,
    reviewSelected: null,
    reviewSelectedIndex: null,
    reviewProductTitle: '',
    reviewsWithImage: null,
    reviewUser: null,
    isFromImageCarousel: null,

    showBeautyTraitsModal: false,
    checkStatusCallback: null,
    showCreditCardOfferModal: false,

    showStoreSwitcherModal: false,
    storeSwitcherOptions: {},
    storeSwitcherAfterCallback: null,

    showSameDayDeliveryLocationModal: false,
    sameDayDeliveryLocationModalCallback: null,
    sameDayDeliveryLocationModalCancelCallback: null
};

// eslint-disable-next-line complexity
const reducer = function (state = initialState, action = {}) {
    switch (action.type) {
        case ACTION_TYPES.SHOW_WIZARD: {
            let toggle = action.isOpen ? action.isOpen : !state.showShadeFinderQuizModal;
            return Object.assign({}, state, {
                showShadeFinderQuizModal: toggle,
                currentProduct: action.currentProduct,
                componentName: action.componentName
            });
        }

        case ACTION_TYPES.SHOW_BCC_MODAL:
            return Object.assign({}, state, {
                isRwd: action.isRwd,
                showBccModal: action.isOpen,
                bccModalTemplate: action.bccModalTemplate
            });

        case ACTION_TYPES.SHOW_SIGN_IN_MODAL:
            return Object.assign({}, state, {
                showSignInModal: action.isOpen,
                signInMessages: action.messages,
                isNewUserFlow: action.isNewUserFlow,
                signInCallback: action.callback,
                signInErrback: action.errback,
                signInSource: action.source,
                analyticsData: action.analyticsData,
                extraParams: action.extraParams
            });

        case ACTION_TYPES.SHOW_AUTHENTICATE_MODAL: {
            const { isOpen, ...restProps } = action;

            return {
                ...state,
                showAuthenticateModal: isOpen,
                ...restProps
            };
        }

        case ACTION_TYPES.SHOW_PHONE_NUMBER_MODAL:
            return Object.assign({}, state, {
                showPhoneNumberModal: action.isOpen,
                reservation: action.reservation,
                activityDetails: action.activityDetails,
                analyticsData: action.analyticsData
            });

        case ACTION_TYPES.SHOW_PAID_RESERVATION_MODAL: {
            const { isOpen, ...restProps } = action;

            return {
                ...state,
                showPaidReservationModal: isOpen,
                ...restProps
            };
        }

        case ACTION_TYPES.SHOW_SIGN_IN_WITH_MESSAGING_MODAL:
            return Object.assign({}, state, {
                showSignInWithMessagingModal: action.isOpen,
                signInMessages: action.messages,
                isPaypalFlow: action.isPaypalFlow,
                isApplePayFlow: action.isApplePayFlow,
                signInCallback: action.callback,
                signInErrback: action.errback,
                isCreditCardApply: action.isCreditCardApply
            });

        case ACTION_TYPES.SHOW_FORGOT_PASSWORD_MODAL:
            return Object.assign({}, state, {
                showForgotPasswordModal: action.isOpen,
                presetLogin: action.email
            });

        case ACTION_TYPES.SHOW_INFO_MODAL:
            return Object.assign({}, state, {
                showInfoModal: action.isOpen,
                infoModalTitle: action.title,
                infoModalMessage: action.message,
                infoModalCallback: action.callback,
                infoModalButtonText: action.buttonText,
                infoModalFooterColumns: action.footerColumns,
                showInfoModalCancelButton: action.showCancelButton,
                infoModalCancelText: action.cancelText,
                infoModalMessageIsHtml: action.isHtml,
                confirmMsgObj: action.confirmMsgObj,
                infoModalCancelCallback: action.cancelCallback,
                showCloseButton: action.showCloseButton,
                dataAt: action.dataAt,
                dataAtTitle: action.dataAtTitle,
                dataAtMessage: action.dataAtMessage,
                dataAtMessageContext: action.dataAtMessageContext,
                dataAtButton: action.dataAtButton,
                dataAtCancelButton: action.dataAtCancelButton,
                dataAtClose: action.dataAtClose
            });

        case ACTION_TYPES.SHOW_KLARNA_MODAL:
            return Object.assign({}, state, {
                showKlarnaModal: action.isOpen,
                klarnaInstallment: action.installmentValue,
                klarnaTotalAmount: action.totalAmount
            });

        case ACTION_TYPES.SHOW_MEDIA_MODAL:
            return Object.assign({}, state, {
                showMediaModal: action.isOpen,
                mediaModalId: action.mediaId,
                mediaModalTitle: action.title,
                mediaModalTitleDataAt: action.titleDataAt,
                mediaModalBodyDataAt: action.modalBodyDataAt,
                mediaModalClose: action.modalClose,
                mediaModalCloseDataAt: action.modalCloseDataAt,
                mediaModalWidth: action.width,
                showMediaTitle: action.showMediaTitle,
                dismissButtonText: action.dismissButtonText,
                dismissButtonDataAt: action.dismissButtonDataAt,
                modalDataAt: action.modalDataAt
            });

        case ACTION_TYPES.SHOW_SAMPLE_MODAL:
            return Object.assign({}, state, {
                showSampleModal: action.isOpen,
                sampleList: action.sampleList,
                allowedQtyPerOrder: action.allowedQtyPerOrder,
                samplesMessage: action.samplesMessage,
                analyticsContext: action.analyticsContext
            });

        case ACTION_TYPES.SHOW_VIDEO_MODAL:
            return Object.assign({}, state, {
                showVideoModal: action.isOpen,
                videoTitle: action.videoTitle,
                videoModalUpdated: action.videoModalUpdated,
                video: action.video
            });

        case ACTION_TYPES.SHOW_PROMO_MODAL:
            return Object.assign({}, state, {
                showPromoModal: action.isOpen,
                promoCode: action.promoCode,
                promosList: action.promosList,
                maxMsgSkusToSelect: action.maxMsgSkusToSelect,
                instructions: action.instructions,
                location: action.location,
                successCallback: action.successCallback
            });

        case ACTION_TYPES.SHOW_COLOR_IQ_MODAL:
            return Object.assign({}, state, {
                showColorIQModal: action.isOpen,
                colorIQModalCallback: action.callback
            });

        case ACTION_TYPES.SHOW_REWARD_MODAL:
            return Object.assign({}, state, { showRewardModal: action.isOpen });

        case ACTION_TYPES.SHOW_APPLY_REWARDS_MODAL:
            return Object.assign({}, state, {
                showApplyRewardsModal: action.isOpen,
                rewardsType: action.rewardsType,
                isBopis: action.isBopis
            });

        case ACTION_TYPES.SHOW_ORDER_CONFIRM_REWARD_MODAL:
            return Object.assign({}, state, {
                showOrderConfirmRewardModal: action.isOpen,
                rewardList: action.rewardList
            });

        case ACTION_TYPES.SHOW_REGISTER_MODAL:
            return Object.assign({}, state, {
                showRegisterModal: action.isOpen,
                presetLogin: action.presetLogin,
                registerCallback: action.callback,
                isStoreUser: action.isStoreUser,
                biData: action.biData,
                registerErrback: action.errback,
                isCreditCardApply: action.isCreditCardApply,
                analyticsData: action.analyticsData,
                extraParams: action.extraParams
            });

        case ACTION_TYPES.SHOW_BI_REGISTER_MODAL:
            return Object.assign({}, state, {
                showBiRegisterModal: action.isOpen,
                biRegisterCallback: action.callback,
                biRegisterCancellationCallback: action.cancellationCallback,
                isCommunity: action.isCommunity,
                isCreditCardApply: action.isCreditCardApply,
                analyticsData: action.analyticsData,
                extraParams: action.extraParams
            });

        case ACTION_TYPES.SHOW_QUICK_LOOK_MODAL:
            return Object.assign({}, state, {
                showQuickLookModal: action.isOpen,
                showAddToBasketModal: action.isOpen ?
                    false : state.showAddToBasketModal,
                skuType: action.skuType,
                quickLookSku: action.sku,
                isCertonaProduct: action.isCertonaProduct,
                error: action.error,
                platform: action.platform,
                origin: action.origin,
                analyticsContext: action.analyticsContext,
                rootContainerName: action.rootContainerName
            });

        case ACTION_TYPES.SHOW_ADD_TO_BASKET_MODAL: {
            const {
                analyticsContext,
                basketType,
                error,
                isCertonaProduct,
                isOpen: showAddToBasketModal,
                preferredStoreName,
                product: addedProduct,
                qty: itemQty,
                sku: addedSku
            } = action.payload;

            return {
                ...state,
                analyticsContext,
                basketType,
                error,
                isCertonaProduct,
                showAddToBasketModal,
                preferredStoreName,
                addedProduct,
                itemQty,
                addedSku
            };
        }

        case ACTION_TYPES.SHOW_EMAIL_WHEN_IN_STOCK_MODAL:
            return Object.assign({}, state, {
                showQuickLookModal: false,
                showEmailMeWhenInStockModal: action.isOpen,
                emailInStockProduct: action.product,
                emailInStockSku: action.currentSku,
                isQuickLook: action.isQuickLook,
                updateEmailButtonCTA: action.updateEmailButtonCTA,
                isComingSoon: action.isComingSoon,
                analyticsContext: action.analyticsContext
            });

        case ACTION_TYPES.UPDATE_QUICK_LOOK:
            return Object.assign({}, state, {
                quickLookProduct: action.quickLookProduct,
                sku: action.sku
            });

        case ACTION_TYPES.SHOW_COUNTRY_SWITCHER_MODAL:
            return Object.assign({}, state, {
                showCountrySwitcherModal: action.isOpen,
                desiredCountry: action.desiredCountry,
                desiredLang: action.desiredLang,
                switchCountryName: action.switchCountryName
            });

        case ACTION_TYPES.SHOW_INTERNATIONAL_SHIPPING_MODAL:
            return Object.assign({}, state, { showInternationalShippingModal: action.isOpen });

        case PROFILE_ACTION_TYPES.SHOW_EDIT_MY_PROFILE_MODAL:
            return Object.assign({}, state, {
                showEditMyProfileModal: action.isOpen,
                saveBeautyTraitCallBack: action.saveBeautyTraitCallBack
            });

        case PROFILE_ACTION_TYPES.SHOW_EDIT_FLOW_MODAL:
            return Object.assign({}, state, {
                showEditFlowModal: action.isOpen,
                editFlowTitle: action.title,
                editFlowContent: action.content,
                biAccount: action.biAccount,
                socialProfile: action.socialProfile,
                saveProfileCallback: action.saveProfileCallback
            });

        case ACTION_TYPES.SHOW_SHARE_LINK_MODAL:
            return Object.assign({}, state, {
                showShareLinkModal: action.isOpen,
                title: action.title,
                shareUrl: action.shareUrl,
                subTitle: action.subTitle
            });
        case ACTION_TYPES.SHOW_CANCEL_RESERVATION_MODAL:
            return Object.assign({}, state, {
                showCancelReservationModal: action.isOpen,
                title: action.title,
                activityDetails: action.activityDetails
            });

        case ACTION_TYPES.SHOW_ORDER_CANCELATION_MODAL:
            return Object.assign({}, state, {
                showOrderCancelationModal: action.isOpen,
                canceledOrderId: action.canceledOrderId,
                selfCancelationReasons: action.selfCancelationReasons
            });

        case ACTION_TYPES.SHOW_PRODUCT_FINDER_MODAL:
            return Object.assign({}, state, {
                showProductFinderModal: action.isOpen,
                guidedSellingData: action.bccData
            });

        case ACTION_TYPES.SHOW_FIND_IN_STORE_MODAL:
            return Object.assign({}, state, {
                showFindInStoreModal: action.isOpen,
                currentProduct: action.currentProduct,
                zipCode: action.zipCode,
                searchedDistance: action.searchedDistance,
                storesToShow: action.storesToShow
            });

        case ACTION_TYPES.SHOW_FIND_IN_STORE_MAP_MODAL:
            return Object.assign({}, state, {
                showFindInStoreMapModal: action.isOpen,
                currentProduct: action.currentProduct,
                selectedStore: action.selectedStore,
                zipCode: action.zipCode,
                searchedDistance: action.searchedDistance,
                storesToShow: action.storesToShow,
                useBackToStoreLink: action.useBackToStoreLink
            });

        case PROFILE_ACTION_TYPES.SHOW_SOCIAL_REGISTRATION_MODAL:
            return Object.assign({}, state, {
                showSocialRegistrationModal: action.isOpen,
                socialRegistrationProvider: action.socialRegistrationProvider
            });

        case PROFILE_ACTION_TYPES.SHOW_SOCIAL_REOPT_MODAL:
            return Object.assign({}, state, {
                showSocialReOptModal: action.isOpen,
                socialReOptCallback: action.socialReOptCallback,
                socialReOptCancellationCallback: action.cancellationCallback
            });

        case ACTION_TYPES.SHOW_ROUGE_REWARD_CARD_MODAL:
            return Object.assign({}, state, {
                showRougeRewardCardModal: action.isOpen,
                rougeRewardCardModalSku: action.sku,
                rougeRewardCardModalCallback: action.callback,
                analyticsContext: action.analyticsContext
            });

        case ACTION_TYPES.SHOW_BOOK_WIDGET_MODAL:
            return Object.assign({}, state, {
                showBookWidgetModal: action.isOpen,
                experienceDetail: action.experienceDetail
            });

        case ACTION_TYPES.SHOW_GOOGLE_MAP_MODAL:
            return Object.assign({}, state, {
                showGoogleMapModal: action.isOpen,
                activity: action.activity,
                selectedStore: action.selectedStore,
                onRequestClose: action.onRequestClose,
                analyticsData: action.analyticsData
            });

        case ACTION_TYPES.SHOW_CREDIT_CARD_PRESCREEN_MODAL:
            return Object.assign({}, state, {
                showCreditCardPrescreenModal: action.isOpen,
                response: action.response
            });

        case ACTION_TYPES.SHOW_SCAN_REWARD_CARD_MODAL:
            return Object.assign({}, state, { showScanRewardCardModal: action.isOpen });

        case ACTION_TYPES.SHOW_CREDIT_REPORT_DETAILS_MODAL:
            return Object.assign({}, state, {
                showCreditReportDetailsModal: action.isOpen,
                content: action.content
            });

        case ACTION_TYPES.SHOW_EXTEND_SESSION_MODAL:
            return Object.assign({}, state, { showExtendSessionModal: action.isOpen });

        case ACTION_TYPES.SHOW_EXTEND_SESSION_FAILURE_MODAL:
            return Object.assign({}, state, { showExtendSessionFailureModal: action.isOpen });

        case ACTION_TYPES.SHOW_PRODUCT_MEDIA_ZOOM_MODAL:
            return Object.assign({}, state, {
                showProductMediaZoomModal: action.isOpen,
                sku: action.sku,
                product: action.product,
                index: action.index,
                mediaItems: action.mediaItems
            });

        case ACTION_TYPES.SHOW_ADDRESS_VERIFICATION_MODAL:
            return Object.assign({}, state, {
                showAddressVerificationModal: action.isOpen,
                verificationType: action.verificationType,
                currentAddress: action.currentAddress,
                recommendedAddress: action.recommendedAddress,
                verificationSuccessCallback: action.successCallback,
                verificationCancelCallback: action.cancelCallback
            });

        case ACTION_TYPES.SHOW_SIMILAR_PRODUCTS_MODAL:
            return Object.assign({}, state, {
                showSimilarProducts: action.isOpen,
                brandName: action.brandName,
                productName: action.productName,
                productImages: action.productImages,
                itemId: action.itemId,
                analyticsContext: action.analyticsContext,
                badgeAltText: action.badgeAltText,
                isYouMayAlsoLike: action.isYouMayAlsoLike,
                productId: action.productId,
                analyticsData: action.analyticsData,
                isCleanProductsModal: action.isCleanProductsModal,
                recommendedProductIDs: action.recommendedProductIDs
            });

        case ACTION_TYPES.SHOW_UFE_MODAL:
            return Object.assign({}, state, {
                showUFEModal: action.isOpen,
                ufeModalId: action.ufeModalId
            });

        case ACTION_TYPES.SHOW_RESERVE_AND_PICK_UP_MODAL:
            return Object.assign({}, state, {
                showReserveAndPickUpModal: action.isOpen,
                reserveAndPickUpModalCallback: action.callback,
                reserveAndPickUpModalMountCallback: action.mountCallback,
                reserveAndPickUpModalCancelCallback: action.cancelCallback,
                currentProduct: action.currentProduct,
                location: action.location,
                searchedDistance: action.searchedDistance,
                storesToShow: action.storesToShow,
                pickupInsteadModalRef: action.pickupInsteadModalRef,
                disableNonBopisStores: action.disableNonBopisStores,
                disableOutOfStockStores: action.disableOutOfStockStores,
                isRopisSelected: action.isRopisSelected
            });

        case ACTION_TYPES.SHOW_REVIEW_IMAGE_MODAL:
            return Object.assign({}, state, {
                showReviewImageModal: action.isOpen,
                reviewProductTitle: action.reviewProductTitle,
                reviewSelected: action.reviewSelected,
                reviewSelectedIndex: action.reviewSelectedIndex,
                reviewUser: action.reviewUser,
                reviewsWithImage: action.reviewsWithImage,
                reviewsReference: action.reviewsReference,
                reviewSelectedPhotoId: action.reviewSelectedPhotoId,
                isFromImageCarousel: action.isFromImageCarousel
            });

        case ACTION_TYPES.SHOW_BEAUTY_TRAITS_MODAL:
            return Object.assign({}, state, {
                showBeautyTraitsModal: action.isOpen,
                checkStatusCallback: action.checkStatusCallback
            });

        case ACTION_TYPES.SHOW_CREDIT_CARD_OFFER_MODAL:
            return Object.assign({}, state, {
                showCreditCardOfferModal: action.isOpen
            });

        case ACTION_TYPES.SHOW_STORE_SWITCHER_MODAL:
            return Object.assign({}, state, {
                showStoreSwitcherModal: action.isOpen,
                storeSwitcherOptions: action.options,
                storeSwitcherAfterCallback: action.afterCallback
            });

        case ACTION_TYPES.SHOW_SAME_DAY_DELIVERY_LOCATION_MODAL:
            return Object.assign({}, state, {
                showSameDayDeliveryLocationModal: action.isOpen,
                sameDayDeliveryLocationModalCallback: action.callback,
                sameDayDeliveryLocationModalCancelCallback: action.cancelCallback
            });

        case ACTION_TYPES.SHOW_CURBSIDE_PICKUP_CHECKIN_MODAL:
            return Object.assign({}, state, {
                showCurbsidePickupCheckinModal: action.isOpen,
                isCurbsideAvailable: action.isCurbsideAvailable
            });

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
